import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { PointCreationService } from '../../../shared/services/point-creation.service';

@Component({
  selector: 'app-create-new-point',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './create-new-point.component.html',
  styleUrl: './create-new-point.component.scss'
})
export class CreateNewPointComponent {
  private pointCreationService = inject(PointCreationService);

  /**
   * Navigate to edit-point page to create a new recycling point
   */
  async createNewPoint(): Promise<void> {
    await this.pointCreationService.startCreationFlow();
  }
}